import RenderMobileEntityOptions from './mobileOptions'
import RenderEntityOption from './option'
import { FormState } from '@/state'

import './styles.scss'

export default function RenderFormEntities() {
  return (
    <div className='entities-options'>
      <RenderMobileEntityOptions />
      {FormState.currentForm.value
        .filter((entity) => entity.permission?.read && entity.render)
        .map((entity, idx) => (
          <RenderEntityOption
            key={entity.name}
            entity={entity}
            index={idx + 1}
          />
        ))}
    </div>
  )
}
